if (!customElements.get('theme-popup')) {
  customElements.define(
    'theme-popup',
    class ThemePopup extends HTMLElement {
      constructor() {
        super();
      }

      open() {
        this.hidden = false;
        document.body.classList.add('theme-popup-open');

        this.setupCloseButton();

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.close();
          }
        }, { once: true });
      }

      close() {
        this.hidden = true;
        document.body.classList.remove('theme-popup-open');
      }

      connectedCallback() {
        this.innerElement = document.createElement('div');
        this.innerElement.classList.add('theme-popup-inner');
        this.appendChild(this.innerElement);

        this.addEventListener('click', (event) => {
          if (event.target === this) {
            this.close();
          }
        });
      }

      setContent(content = '') {
        if (content instanceof HTMLElement) {
          this.innerElement.innerHTML = '';
          this.innerElement.appendChild(content);
        } else {
          this.innerElement.innerHTML = content;
        }
      }

      setupCloseButton() {
        this.closeButtons = this.querySelectorAll('.theme-popup-close');

        this.closeButtons.forEach((closeButton) => {
          closeButton.addEventListener('click', () => {
            this.close();
          });
        });
      }
    }
  );
}
